import { variables } from '@indriver/yrel';

var preset = {
  borderDefault: variables['background-secondary'],
  borderFocused: variables['border-selected'],
  borderDisabled: variables['background-disabled'],
  borderInvalid: variables['extensions-border-error'],
  borderHover: variables['statement-background-secondarypressed'],
  backgroundDefault: variables['background-secondary'],
  backgroundHover: variables['statement-background-secondarypressed'],
  backgroundDisabled: variables['background-disabled'],
  backgroundFocused: variables['background-secondary'],
  backgroundInvalid: variables['background-secondary'],
  placeholderColor: variables['text-and-icon-secondary'],
  textColor: variables['text-and-icon-primary'],
  textColorDisabled: variables['text-and-icon-disabled'],
  iconFocusedColor: variables['text-and-icon-primary'],
  iconColor: variables['text-and-icon-disabled']
};
var floatingContainerPreset = {
  padding: {
    default: '0 16px',
    prefixed: '0 16px 0 50px',
    postfixed: '0 50px 0 16px',
    both: '0 50px'
  }
};

export { preset as default, floatingContainerPreset };
